import { Box, Stack, Strong, Text } from 'braid-design-system';
import React from 'react';

import { QuotationMarkSVG } from './svg/QuotationMarkSVG';

import * as styles from './TestimonialCard.css';
import type { CTestimonial } from '@seek/cmsu-cms-connect';

export const TestimonialCard = ({
  testimonial,
}: {
  testimonial: CTestimonial;
}) => (
  <Box
    className={styles.testimonialCard}
    padding="gutter"
    borderRadius="xlarge"
    data={{ testid: 'testimonial-card' }}
  >
    <Stack space="medium">
      <Box className={styles.quote}>
        <Stack space="medium">
          <QuotationMarkSVG />
          <Text tone="secondary">{testimonial.quote}</Text>
        </Stack>
      </Box>
      <Stack space="small">
        <Text tone="secondary" size="small">
          <Strong>{testimonial.author}</Strong>
        </Text>
        {testimonial.company ? (
          <Text tone="secondary" size="small">
            {testimonial.company}
          </Text>
        ) : null}
      </Stack>
    </Stack>
  </Box>
);
